import { Link } from 'react-router'

const LINKS = [
  { to: '/privacy', label: 'Privacy' },
  { to: '/terms', label: 'Terms' },
]

export function SiteFooter() {
  return (
    <footer className="mt-16 border-t border-line">
      <div className="container-page flex flex-wrap items-center justify-between gap-x-6 gap-y-2 py-5 text-sm text-fg-subtle">
        <p>© {new Date().getFullYear()} Zadrik Software LLC</p>
        <nav aria-label="Legal">
          <ul className="flex gap-5">
            {LINKS.map((link) => (
              <li key={link.to}>
                <Link to={link.to} className="transition-colors hover:text-fg">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </footer>
  )
}
